import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {MemoryRouter as Router, Route, Switch} from 'react-router-dom';
import FormRoute from './form-route';
import SubmitRoute from './submit-route';
import ErrorsRoute from './errors-route';
import ThanksRoute from './thanks-route';
import './PlanYourVisitApp.less';


export default class PlanYourVisitApp extends PureComponent {
  render() {
    const {onSuccess} = this.props;

    return (
      <div className="plan-your-visit-app">
        <Router>
          <Switch>
            <Route exact path='/' component={FormRoute} />
            <Route path='/submit' render={(props) => <SubmitRoute onSuccess={onSuccess} {...props} />} />
            <Route path='/errors' component={ErrorsRoute} />
            <Route path='/thanks' component={ThanksRoute} />
          </Switch>
        </Router>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/PlanYourVisitApp.js